import styled from 'styled-components'

const StyledContainer = styled.div`
  color: ${({ theme }) => theme.palette.primary.main};
`

export default StyledContainer
